export default "__VITE_PUBLIC_ASSET__b0286dd2__"